import React from "react";
import PropTypes from "prop-types";

const GradientBorder = ({ color }) => {
  return (
    <div
      className={`gradient-border gradient-border--${color} w-full absolute bottom-0 right-0 left-0`}
    ></div>
  );
};

GradientBorder.defaultProps = {
  color: `shampoo`
};

GradientBorder.propTypes = {
  color: PropTypes.string
};

export default GradientBorder;
